import { SupportTicketService } from "@/ServerTypes/Administration/SupportTicketService";
import { alertDialog, DialogTexts, ErrorHandling, Fluent, htmlEncode, notifyError, notifySuccess } from "@serenity-is/corelib";

ErrorHandling.showServiceError = function (error: any) {
    var id = 'ErrorDialog_' + new Date().getTime();

    function removeEventListeners(el: HTMLElement) {
        const elClone = el.cloneNode(true) as HTMLElement;
        el.parentNode?.replaceChild(elClone, el);
        return elClone;
    }

    let msg: string;
    let errorDetails: string;
    if (error == null) {
        msg = '??ERROR??';
        errorDetails = '';
    }
    else {
        msg = error.Message;
        if (msg == null) {
            msg = error.Code;
        }
        errorDetails = `Error Id:${error.ErrorId}. Details:${error.Details}`;
    }

    alertDialog(<>
        {error?.Details ? <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href={`#${id}_Error`}>Error</a></li>
            <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href={`#${id}_Details`}>Details</a></li>
        </ul> : null}
        <div class="tab-content">
            <div id={`${id}_Error`} class="tab-pane fade show active error-pane">
                <div class="message-text">{msg}</div>
            </div>
            {error?.Details ? <div id={`${id}_Details`} class="tab-pane fade details">{errorDetails}</div> : null}
        </div></>, {
        dialogClass: "s-AlertDialog s-MatrixErrorDialog s-MessageDialog",
        size: "lg",
        width: '60%' as any,
        onOpen: function () {
            var uidlg = Fluent(this).findFirst('.modal-content');
            uidlg.findFirst(".message").style(x => x.overflowX = "auto");
            removeEventListeners(uidlg.findFirst('.copy-button')[0]);
            uidlg.findFirst('.copy-button').on("click", () => {
                var copyCommand = null;
                if (navigator.clipboard)
                    copyCommand = (s: string) => navigator.clipboard.writeText(s);

                if (!copyCommand && (document as any).queryCommandSupported('copy')) {
                    copyCommand = (s: string) => {
                        var fakeElement = document.createElement('textarea');
                        fakeElement.style.position = 'absolute';
                        fakeElement.style.left = '-9999px';
                        fakeElement.style.top = (window.scrollY || document.documentElement.scrollTop) + 'px';
                        fakeElement.setAttribute('readonly', '');
                        fakeElement.value = s;
                        document.body.append(fakeElement);
                        fakeElement.select();
                        (document as any).execCommand("copy");
                        fakeElement.remove();
                    }
                }

                if (!copyCommand) {
                    notifyError("Copy to clipboard is not supported");
                    return;
                }
                var txt = uidlg.findFirst('.tab-pane').text();
                try {
                    copyCommand(txt);
                    notifySuccess("Copied error to clipboard.");
                } catch (error) {
                    notifyError("Sorry, an error occurred while trying to copy to the clipboard");
                }
            });

            removeEventListeners(uidlg.findFirst('.ticket-button')[0]);
            uidlg.findFirst('.ticket-button')
                .toggleClass("d-none", !error)
                .on("click", () => {
                    SupportTicketService.SendEmail({
                        ErrorId: error?.ErrorId,
                        Path: window.location.pathname + window.location.search + window.location.hash,
                    },
                        () => {
                            notifySuccess('Details of the error have been emailed to the support team.');
                            (Fluent(this) as any).modal('hide');
                        });
                });
        },
        buttons: [
            {
                text: 'Copy',
                cssClass: 'copy-button'
            },
            {
                text: 'Open Support Ticket',
                cssClass: 'ticket-button d-none'
            },
            {
                text: DialogTexts.OkButton,
                result: 'ok'
            }
        ]
    });

}